import type { FieldType } from "@/schemas/digital-files";

export const OWNER_ROLE_ID = "_owner_";

export type EntityModalState =
  "activate" | "deactivate" | "reactivate" | "idle";

export interface Section {
  id: string;
  title: string;
  order: number;
  description?: string;
  fields: FieldType[];
}

export type FieldTypeName =
  | "text"
  | "number"
  | "textarea"
  | "date"
  | "date_range"
  | "email"
  | "phone"
  | "select"
  | "multiselect"
  | "identification"
  | "file"
  | "interoperability"
  | "switch";

export interface EntityField {
  id: string;
  type: FieldTypeName;
  name: string;
  key: string;
  is_array: boolean;
  max_items: number | null;
  required: boolean;
  [key: string]: unknown; // Para campos dinámicos adicionales
}
